<template>
  <div class="hcl-tiles-tile-content-empty"></div>
</template>

<script setup lang="ts">
</script>
